<template>
  <div class="dept_container">
    <div class="department_title">
      菜单查询
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="部门名称：">
        <el-input
          v-model="formInline.deptName"
          placeholder="请输入部门名称"
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="状态：" class="left_margin">
        <el-select v-model="formInline.status" placeholder="部门状态" clearable>
          <el-option label="正常" value="0"></el-option>
          <el-option label="停用" value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item class="left_margin">
        <el-button type="primary" @click="onSubmit" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="newly_built">
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="newly_built_btn"
        @click="menuAdd"
        v-if="premission('system:menu:add')"
        >新建菜单</el-button
      >
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="menuId"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="menuName" label="菜单名" width="180">
      </el-table-column>
      <el-table-column prop="orderNum" label="排序" width="180">
      </el-table-column>

      <el-table-column prop="path" label="URL" width="180"> </el-table-column>
      <el-table-column prop="updateBy" label="修改人" width="180">
      </el-table-column>
      <el-table-column prop="createTime" label="修改日期" width="180">
      </el-table-column>
      <el-table-column label="是否显示" width="180">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#F6B439"
            inactive-color="#ff4949"
            active-value="0"
            inactive-value="1"
            @change="switch_value_btn(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="operation_right"
            icon="el-icon-plus"
            @click="menuAdd(scope.row)"
            v-if="premission('system:menu:add')"
            >添加菜单</el-button
          >
          <el-button
            type="text"
            class="operation_right"
            icon="el-icon-edit-outline"
            @click="redact(scope.row)"
            v-if="premission('system:menu:edit')"
            >编辑</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="Delete(scope.row)"
            v-if="premission('system:menu:remove')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增菜单弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="sizeForm"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="上级菜单:" prop="parentId">
          <treeselect
            v-model="sizeForm.parentId"
            :options="menuOptions"
            :normalizer="normalizer"
            :show-count="true"
            placeholder="选择上级菜单"
          />
        </el-form-item>
        <el-form-item label="菜单类型:" prop="menuType">
          <el-radio v-model="sizeForm.menuType" label="M">目录</el-radio>
          <el-radio v-model="sizeForm.menuType" label="C">菜单</el-radio>
          <el-radio v-model="sizeForm.menuType" label="F">按钮</el-radio>
        </el-form-item>
        <el-form-item
          v-if="sizeForm.menuType == 'C' || sizeForm.menuType == 'M'"
          label="菜单名称:"
          prop="menuName"
        >
          <el-input
            v-model="sizeForm.menuName"
            placeholder="请输入菜单名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          v-if="sizeForm.menuType == 'C'"
          label="菜单图标:"
          prop="icon"
        >
          <el-input
            v-model="sizeForm.icon"
            placeholder="请输入菜单图标"
          ></el-input>
        </el-form-item> -->
        <el-form-item
          v-if="sizeForm.menuType == 'F'"
          label="按钮名称:"
          prop="menuName"
        >
          <el-input
            v-model="sizeForm.menuName"
            placeholder="请填写按钮名称"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="sizeForm.menuType == 'F'" label="权限字符:">
          <el-input
            v-model="sizeForm.perms"
            placeholder="填写权限字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示排序:" prop="orderNum">
          <el-input
            v-model="sizeForm.orderNum"
            placeholder="填写排序"
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="sizeForm.menuType == 'C' || sizeForm.menuType == 'M'"
          label="路由地址:"
          prop="path"
        >
          <el-input
            v-model="sizeForm.path"
            placeholder="请填写菜单路由地址"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="sizeForm.menuType == 'C' || sizeForm.menuType == 'M'"
          label="显示状态:"
        >
          <el-radio v-model="sizeForm.status" label="0">显示</el-radio>
          <el-radio v-model="sizeForm.status" label="1">不显示</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="add_new_btn" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改菜单 -->
    <!-- <el-dialog
      title="新建菜单"
      :visible.sync="dialogVisibleRedact"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="sizeForm"
        label-width="90px"
        size="mini"
      >
        <el-form-item label="菜单名称">
          <el-input
            v-model="redactForm.menuName"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单排序">
          <el-input-number
            v-model="redactForm.orderNum"
            controls-position="right"
            @change="handleChange"
            :min="1"
            :max="20"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="菜单状态">
          <el-radio v-model="redactForm.status" label="0">正常</el-radio>
          <el-radio v-model="redactForm.status" label="1">停用</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleRedact = false">取 消</el-button>
        <el-button type="primary" @click="updateMenuAjax" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import premission from "../../utils/permission";
import {
  changeMenuStatus,
  MenuListsAjax,
  getMenu,
  addMenu,
  MenuDeleteAjax,
  updateMenu
} from "../../api/index";
import { handleTree } from "../../utils/treating";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  mixins: [premission],
  data() {
    return {
      // 弹出层标题
      title: "",
      // 修改菜单弹窗
      dialogVisibleRedact: false,
      // 新建公司弹窗
      dialogVisible: false,
      // //是否显示
      // switch_value: "1",
      // 搜索数据
      formInline: {
        deptName: "",
        status: ""
      },
      // 节流阀
      throttle: "true",
      // 新建公司数据
      sizeForm: {
        perms: "",
        parentId: "",
        menuName: undefined,
        path: "",
        icon: "",
        menuType: "M",
        orderNum: undefined,
        isFrame: "1",
        isCache: "0",
        visible: "0",
        status: "0"
      },
      // 表单数据
      tableData: [],
      // 菜单树选项
      menuOptions: [],
      // 表单校验
      rules: {
        parentId: [
          { required: true, message: "上级菜单不能为空", trigger: "blur" }
        ],
        menuName: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "显示排序不能为空", trigger: "blur" }
        ],
        path: [{ required: true, message: "菜单URL不能为空", trigger: "blur" }],
        menuType: [
          { required: true, message: "选择菜单类型", trigger: "blur" }
        ],
        icon: [{ required: true, message: "菜单图标不能为空", trigger: "blur" }]
      }
    };
  },
  created() {
    this.getMenuListsAjax();
  },
  methods: {
    //搜索
    async onSubmit() {
      if (!this.throttle) return;
      this.throttle = false;
      const { data: res } = await MenuListsAjax(this.formInline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.throttle = true;
      this.tableData = handleTree(res.data, "menuId");
    },
    // 重置
    reset() {
      this.formInline.status = "";
      this.formInline.deptName = "";
      this.getMenuListsAjax();
    },
    // 获取表单数据
    async getMenuListsAjax() {
      const { data: res } = await MenuListsAjax();
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.tableData = handleTree(res.data, "menuId");
    },
    // 新增按钮
    menuAdd(row) {
      this.dialogVisible = true;
      this.getTreeselect();
      if (row != null && row.menuId) {
        this.sizeForm.parentId = row.menuId;
      } else {
        this.sizeForm.parentId = 0;
      }
      this.title = "新建菜单";
    },
    // 编辑按钮
    async redact(e) {
      this.getTreeselect();
      const { data: res } = await getMenu(e.menuId);
      this.sizeForm = res.data;
      this.title = "编辑菜单";
      this.dialogVisible = true;
    },
    //修改菜单请求
    async updateMenuAjax() {
      const { data: res } = await updateMenu(this.sizeForm);
      if (res.code !== 200) {
        return this.$message({
          message: res.msg,
          type: "error"
        });
      } else {
        this.$message({
          type: "success",
          message: res.msg
        });
        this.throttle = true;
        this.getMenuListsAjax();
        this.dialogVisible = false;
        this.sizeForm = {
          parentId: "",
          menuName: undefined,
          path: "",
          icon: "",
          menuType: "M",
          orderNum: undefined,
          isFrame: "1",
          isCache: "0",
          visible: "0",
          status: "0"
        };
      }
    },
    // 新建公司弹窗确认和取消
    async add_new_btn() {
      if (!this.throttle) return;
      this.throttle = false;
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.title == "新建菜单") {
            const { data: res } = await addMenu(this.sizeForm);
            if (res.code !== 200) {
              return this.$message({
                message: res.msg,
                type: "error"
              });
            } else {
              this.throttle = true;
              this.dialogVisible = false;
              this.sizeForm = {
                parentId: 0,
                menuName: undefined,
                path: "",
                icon: "",
                menuType: "M",
                orderNum: undefined,
                isFrame: "1",
                isCache: "0",
                visible: "0",
                status: "0"
              };
              this.getMenuListsAjax();
              return this.$message({
                message: res.msg,
                type: "success"
              });
            }
          }
          if (this.title == "编辑菜单") {
            this.updateMenuAjax();
          }
        } else {
          return false;
        }
      });
    },
    // 弹窗是否关闭按钮
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.dialogVisible = false;
          this.sizeForm = {
            parentId: 0,
            menuName: undefined,
            path: "",
            icon: "",
            menuType: "M",
            orderNum: undefined,
            isFrame: "1",
            isCache: "0",
            visible: "0",
            status: "0"
          };
        })
        .catch(_ => {});
    },
    // 删除部门
    Delete(e) {
      this.open(e);
    },

    open(e) {
      this.$confirm(`是否确认删除名称为"${e.menuName}"的数据项？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data: res } = await MenuDeleteAjax(e.menuId);
          if (res.code !== 200)
            return this.$message({
              type: "error",
              message: res.msg
            });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getMenuListsAjax();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 修改开关状态
    switch_value_btn(row) {
      let text = row.status === "0" ? "显示" : "隐藏";
      this.$confirm(
        '确认要"' + text + '""' + row.menuName + '"菜单吗?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          console.log(1);
          const { data: res } = await changeMenuStatus(row.menuId, row.status);
          if (res.code !== 200) {
            row.status = row.status === "0" ? "1" : "0";
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
        })
        .catch(() => {
          row.status = row.status === "0" ? "1" : "0";
        });

      // .then(function() {
      //   return changeMenuStatus(row.menuId, row.status);
      // })
      // .then(() => {
      //   if (res.data.code !== 200)
      //     return this.$message({
      //       type: "success",
      //       message: res.data.msg
      //     });
      // })
      // .catch(function() {
      //
      // });
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.menuId,
        label: node.menuName,
        children: node.children
      };
    },
    /** 查询菜单下拉树结构 */
    async getTreeselect() {
      const { data: res } = await MenuListsAjax();
      this.menuOptions = [];
      const menu = { menuId: 0, menuName: "主类目", children: [] };
      menu.children = handleTree(res.data, "menuId");
      this.menuOptions.push(menu);
    },
    cancel() {
      this.dialogVisible = false;
      this.sizeForm = {
        parentId: "",
        menuName: undefined,
        path: "",
        icon: "",
        menuType: "C",
        orderNum: undefined,
        isFrame: "1",
        isCache: "0",
        visible: "0",
        status: "0"
      };
    }
  }
};
</script>

<style lang="less" scoped>
.department_title {
  width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
.el-form-item--mini.el-form-item {
  margin-bottom: 24px;
  height: 36px;
  /deep/.el-form-item__content {
    height: 36px;
    .el-input--mini {
      height: 36px;
      input {
        height: 36px;
      }
    }
  }
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 200px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 108px;
    height: 36px;
    text-align: center;
    padding: 0;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
}
.operation_right {
  margin-right: 20px;
}

/deep/.el-table th {
  text-align: center;
  background-color: #f2f2f2;
}
/deep/ .el-table__row td {
  text-align: center;
}

.dialog-footer {
  .add_new_btn {
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
  }
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-weight: normal;
  }
}
/deep/.el-form-item--mini .el-form-item__label {
  font-weight: normal;
  color: #000;
  font-size: 16px;
}
/deep/.el-dialog {
  border-radius: 10px;
  padding: 10px 16px;
  .el-dialog__headerbtn {
    top: 36px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #000;
  }
}
/deep/.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 36px;
  font-size: 16px;
}
.menuType {
  width: 438px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 7px;
  height: 7px;
}
.el-dialog__footer {
  button {
    text-align: center;
    line-height: 13px;
    width: 72px;
    height: 36px;
  }
}
</style>
